function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuroLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {},
    fill: "#2196f3",
    "data-original": "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.008 339.744C299.072 347.872 285.952 352 272 352c-29.472 0-55.008-19.456-68.864-48H256c8.832 0 16-7.168 16-16s-7.168-16-16-16h-62.656c-.736-5.216-1.344-10.528-1.344-16s.608-10.784 1.344-16H272c8.832 0 16-7.168 16-16s-7.168-16-16-16h-68.864c13.856-28.544 39.392-48 68.864-48 13.952 0 27.072 4.128 39.008 12.256 7.264 4.96 17.248 3.168 22.208-4.192 4.96-7.296 3.104-17.248-4.224-22.24C311.904 134.176 292.192 128 272 128c-46.88 0-87.008 33.184-103.68 80H144c-8.832 0-16 7.168-16 16s7.168 16 16 16h17.408c-.576 5.312-1.408 10.528-1.408 16 0 5.472.832 10.688 1.408 16H144c-8.832 0-16 7.168-16 16s7.168 16 16 16h24.32c16.672 46.816 56.8 80 103.68 80 20.192 0 39.904-6.176 56.992-17.824 7.328-4.992 9.184-14.944 4.224-22.24s-14.976-9.12-22.208-4.192z",
    style: {},
    fill: "#fafafa",
    "data-original": "#fafafa",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroLogo);
export default __webpack_public_path__ + "static/media/euro-logo.05cde0c0b4c501eb88ec5575b7e81366.svg";
export { ForwardRef as ReactComponent };